import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentsDetailPres from 'src/ui/features/Documents/presentational/DocumentsDetailPres';
import { isEYProSelector } from 'src/ui/features/Login/state/loginReselect';
import { addToHistory } from 'src/utils/utilsActions';

export class DocumentsDetailContainer extends Component {
  componentDidMount() {
    const { caseManagerId, documentid } = this.props.match.params;
    this.props.addToHistory(window.location.pathname, { caseManagerId, documentid });
  }

  render() {
    return <DocumentsDetailPres {...this.props} />;
  }
}

const mapDispatchToProps = {
  addToHistory,
};

const mapStateToProps = state => ({
  documentDetail: state.documents.documentDetail,
  isEYPro: isEYProSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsDetailContainer);
